import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ComentariosmedicaoService } from 'src/app/services/financeiro/comentariosmedicao.service';
import { MedicaoService } from 'src/app/services/financeiro/medicao.service';
import { AuthService } from 'src/app/services/vos/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-comentariosnewmedicao',
  templateUrl: './comentariosnewmedicao.component.html',
  styleUrls: ['./comentariosnewmedicao.component.css']
})
export class ComentariosnewmedicaoComponent implements OnInit {
  comentario: any
  comentarios: Array<any> = []
  @Input() medicao: any
  usuario: any;
  inscricao: Subscription;
  constructor(
    private authService: AuthService,
    private medicaoService: MedicaoService,
    private comentariosmedicaoService: ComentariosmedicaoService) { }

  ngOnInit(): void {
    this.pegaUsuario();
    this.buscaComentariosPorIdMedicao()
  }
  pegaUsuario() {
    this.usuario = JSON.parse(this.authService.getUserLoggedIn());
  }
  buscaComentariosPorIdMedicao() {
    this.comentarios = []
    this.inscricao = this.comentariosmedicaoService.buscaComentariosPorIdMedicao(this.medicao?.id).subscribe(res => {
      this.comentarios = res
    })
  }

  comentarmedicao(comment: string) {
    let comentario = {
      id: null,
      medicoes_id: this.medicao.id,
      pessoa_id: this.usuario.user.pessoa_id,
      comentario: comment,
      data: new DatePipe('pt-Br').transform(Date.now(), "yyyy-MM-dd"),
      hora: new DatePipe('pt-Br').transform(Date.now(), "HH:mm")
    }
    this.inscricao = this.comentariosmedicaoService.save(comentario).subscribe(res => {
      this.buscaComentariosPorIdMedicao()
    }, error => {
      console.log(error);
      Swal.fire("Ops, deu erro!", " Erro ao Reprovar Medição!", "error")
    })
  }
  aprovarMedicao(item) { // corrigido
    item.status = true;
    item.situacao = "Aprovado"
    this.inscricao = this.medicaoService.updateNew(item.id, item).subscribe(
      res => Swal.fire("APROVADO!"),
      error => Swal.fire("Ops, deu erro!", "Não foi possível aprovar Medição.", "error"))
  }
  reprovaMedicao() {
    Swal.fire({
      title: "Informe o motivo da Reprovação da Medição",
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      showLoaderOnConfirm: true,
      preConfirm: (result) => {
        if (!result) {
          Swal.showValidationMessage('Por favor informe o motivo.')
        }
        this.salvarMedicaoReprovada(result)
      },
    })

  }
  salvarMedicaoReprovada(motivo) {
    let comentario = {
      id: null,
      medicoes_id: this.medicao.id,
      pessoa_id: this.usuario.user.pessoa_id,
      comentario: motivo,
      data: new DatePipe('pt-Br').transform(Date.now(), "yyyy-MM-dd"),
      hora: new DatePipe('pt-Br').transform(Date.now(), "HH:mm"),
      medicao: {
        status: false,
        situacao: "Reprovado"
      }
    }
    this.inscricao = this.comentariosmedicaoService.save(comentario).subscribe(res => {
      Swal.fire("REPROVADO!")
      this.buscaComentariosPorIdMedicao()
    }, error => {
      Swal.fire("Ops, deu erro!", " Erro ao Reprovar Medição!", "error")
    })
  }
  ngOnDestory() {
    if(this.inscricao) this.inscricao.unsubscribe();
  }
}
